export default __webpack_public_path__ + "static/media/Interior3.01dc981c.jpg";